import {capitalize} from 'lodash';
import {comparableTypes} from 'lib/PropertyUtils';

export const COMPARABLE_TYPE_TO_URI_MAP = {
  'sales': 'comparable_sales',
  'listings': 'comparable_listings',
  'rentals': 'comparable_rentals',
};
export const PHOTO_GALLERY_FIELDS = [
  'aerialViewImageUri',
  'floorPlanUris',
  'propertyPhotoList',
  'secondaryImageUris',
  'selectedImages',
  'streetViewImageUri',
  'targetPhotoList',
  'uploadPhotoList',
];
export const PROPERTY_AVM_FIELDS = [
  'intelliValAvm',
  'propertyAvm',
  'rentalAvm',
];
export const PROPERTY_HISTORY_FIELDS = [
  'history',
];

export const getComparableKey = (comparableType) => {
  if (comparableTypes.includes(comparableType)) {
    return 'comparable' + capitalize(comparableType);
  }
  throw new Error(`Unrecognized comparable type ${comparableType}`);
};

export const TIMEOUTS = {
  SHORT: 5000,
  DEFAULT: 10000,
  LONG: 30000,
  EXTRA_LONG: 60000,
};

const sortStringArrayNumericLast = arr =>
    arr.sort((a, b) => {
      const aNum = /^\d/.test(a);
      const bNum = /^\d/.test(b);
      if (aNum && !bNum) return 1;
      if (bNum && !aNum) return -1;
      return a.localeCompare(b, undefined, { sensitivity: 'base' });
    });

const Commons = {
  getComparableKey,
  COMPARABLE_TYPE_TO_URI_MAP,
  PHOTO_GALLERY_FIELDS,
  sortStringArrayNumericLast,
};

export default Commons;
